import cskProfile from "../../人物/csk/csk.txt?raw";
import cskCutout from "../../人物/csk/csk-cutout.webp";
import cycProfile from "../../人物/cyc/cyc.txt?raw";
import cycCutout from "../../人物/cyc/cyc-cutout.webp";
import mmProfile from "../../人物/mm/mm.txt?raw";
import mmCutout from "../../人物/mm/mm-cutout.webp";
import wzlProfile from "../../人物/wzl/wzl.txt?raw";
import wzlCutout from "../../人物/wzl/wzl-cutout.webp";
import xjpProfile from "../../人物/xjp/xjp.txt?raw";
import xjpCutout from "../../人物/xjp/xjp-cutout.webp";
import yxmProfile from "../../人物/yxm/yxm.txt?raw";
import yxmCutout from "../../人物/yxm/yxm-cutout.webp";

export type TeamMember = {
  id: string;
  name: string;
  role: string;
  credential?: string;
  biography: string;
  cutout: string;
};

function cleanMarkdown(value: string) {
  return value.replaceAll("**", "").trim();
}

function parseProfile(id: string, raw: string, cutout: string): TeamMember {
  const lines = raw
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  const name = lines[0];
  const secondary = lines[1];
  const roleLine = lines.find((line) => line.startsWith("# "));
  const biography = lines
    .filter(
      (line, index) =>
        index >= 2 && !line.startsWith("# ") && !line.includes("`"),
    )
    .sort((first, second) => second.length - first.length)[0];

  if (!name || !secondary || !biography) {
    throw new Error(`Invalid team profile: ${id}`);
  }

  return {
    id,
    name,
    role: roleLine ? roleLine.slice(2).trim() : secondary,
    credential: roleLine ? secondary : undefined,
    biography: cleanMarkdown(biography),
    cutout,
  };
}

export const teamMembers = [
  parseProfile("csk", cskProfile, cskCutout),
  parseProfile("cyc", cycProfile, cycCutout),
  parseProfile("mm", mmProfile, mmCutout),
  parseProfile("xjp", xjpProfile, xjpCutout),
  parseProfile("yxm", yxmProfile, yxmCutout),
  parseProfile("wzl", wzlProfile, wzlCutout),
];
